"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteDropletsByTag = void 0;
const deleteDropletsByTag = ({ httpClient, }) => ({ tag_name, }) => {
    const path = '/droplets';
    const query_params = { tag_name };
    const url = `${path}`;
    return httpClient.delete(url, { params: query_params });
};
exports.deleteDropletsByTag = deleteDropletsByTag;
//# sourceMappingURL=delete-droplets-by-tag.js.map